import { profileActionTypes } from '../actions/profile-action-types';

const profileInitialState = {
	customer: {},
	storageInBytes: -1,
	photoCount: -1,
	videoCount: -1,
	lastCustomerRequest: -1,
    lastStorageRequest: -1,
    lastStatsRequest: -1
};

export const profile = (state = profileInitialState, action) => {
	switch (action.type) {
		case profileActionTypes.PROFILE_CUSTOMER_SUCCESS:
			return {
				...state,
				customer: action.customer,
				lastCustomerRequest: Date.now()
			};
		case profileActionTypes.PROFILE_STATS_SUCCESS:
			return {
				...state,
				photoCount: action.photoCount,
                videoCount: action.videoCount,
                lastStatsRequest: Date.now()
			};
		case profileActionTypes.PROFILE_STORAGE_SUCCESS:
			return {
				...state,
                storageInBytes: action.storageInBytes,
                lastStorageRequest: Date.now()
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/profile/reducers/profile-reducers.js